<template lang="es">
  <v-app>
    <div>
      <div>
        <div class="mt-4 pl-4 pr-2">
          <span class="display-1">SECADERO</span>
        </div>
        <!-- Leyenda Gráfica -->
        <v-layout class="mt-1">
          <v-flex xs12>
            <div v-if="!loadingData" class="line-chart-secadero">
              <line-chart-nuevo :chartData="chartDataComputed" :chartOptions="chartOptions" :baseLineValue="baseLineValue" ref="lineChartNuevo"></line-chart-nuevo>
            </div>
            <div v-else class="loading-spinner">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <span>Cargando datos...</span>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <!-- Texto "Temperaturas actuales" -->
      <v-layout class="mt-2">
        <v-flex xs12>
          <div class="current-temperatures-title">
            <span>Temperaturas actuales</span>
          </div>
        </v-flex>
      </v-layout>
      <!-- Tabla de Temperaturas -->
      <v-layout class="mt-2">
        <v-flex xs12>
          <v-simple-table class="temperature-table">
            <thead>
              <tr>
                <th v-for="header in tableHeaders" :key="header.value" class="table-header">{{ header.text }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in tableData" :key="index">
                <td>{{ data.timestamp }}</td>
                <td>{{ data.valorTHorno }}ºC</td>
                <td>{{ data.valorTTrabajo }}ºC</td>
                <td>{{ data.valorVSinfines }}Hz</td>
                <td>{{ data.valorTQuemador }}ºC</td>
                <!-- <td>{{ data.timestamp }}</td> -->
              </tr>
            </tbody>
          </v-simple-table>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-layout class="mt-4">
        <v-flex xs12 md2>
          <v-text-field 
            v-model="horizontalLineValue" 
            label="Valor para la limite Temperatura Trabajo" 
            type="number">
          </v-text-field>
        </v-flex>
        <v-flex xs12 md2>
          <v-btn color="primary" @click="addHorizontalLine">Añadir línea</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </v-app>
</template>

<script>
import LineChartNuevo from '@/components/LineChartNuevo.vue';
import { mapActions,mapState } from 'vuex';
import moment from'moment';
export default {
  components: {
    LineChartNuevo
  },
  props: {
  },
  data() {
    return {
      loadingData: true,
      plc_id: 1,
      baseLineValue : null,
      horizontalLineValue: null,
      // Datos del gráfico
      chartData: {
        datasets: [
          {
            id:"DB510DBD56",
            label: "Temperatura trabajo",
            data: [],
            borderColor: "rgba(75, 192, 192, 1)",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            fill: false,
            pointRadius: 0,
            tipoDato: 2,
            lineTension: 0, 
            yAxisID: 'y'
          },
          {
            id:"DB510DBD60",
            label: "Temperatura horno",
            data: [],
            borderColor: "rgba(255, 99, 132, 1)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            fill: false,
            pointRadius: 0,
            tipoDato: 2,
            lineTension: 0, 
            yAxisID: 'y2'

          },
          {
            id:"DB510DBD52",
            label: "Velocidad sinfines alimentadores",
            data: [],
            borderColor: "rgba(0, 102, 204, 1)",
            backgroundColor: "rgba(0, 102, 204, 0.2)",
            fill: false,
            pointRadius: 0,
            tipoDato: 2,
            lineTension: 0, 
            yAxisID: 'y3'

          },
          {
            id:"DB510DBD68",
            label: "Temperatura trabajo quemador",
            data: [],
            borderColor: "rgba(255, 255, 0, 1)",
            backgroundColor: "rgba(255, 255, 0, 0.2)",
            fill: false,
            pointRadius: 0,
            tipoDato: 2,
            lineTension: 0, 
            yAxisID: 'y'

          },
        ]
      },
      // Configuración del gráfico
      chartOptions: {
        
      },
      // Datos para la tabla (una fila para cada temperatura)
      tableData: [
        { timestamp: '', valorTHorno: '', valorTTrabajo: '',valorVSinfines: '', valorTQuemador:''}

      ],
      tableHeaders: [
        { text: 'Hora', value: 'timestamp'},
        { text: 'Tº Trabajo', value: 'tTrabajo' },
        { text: 'Tº Horno', value: 'tHorno' },
        { text: 'Velocidad Sinfines Alimentadores ', value: 'vSinfines'},
        { text: 'Tº trabajo Quemador', value: 'tQuemador'}
      ]
    } 
  },

  computed: {
    ...mapState('nodered',['client']),
    chartDataComputed() {
      return this.chartData;;
    }
  },
  methods: {
  ...mapActions('nodered',['doSubscribe']),
  ...mapActions(['getData','postData']),

  async addHorizontalLine() {
    
    const newValue = parseFloat(this.horizontalLineValue);
    if (!isNaN(newValue)) {
      this.baseLineValue = newValue; // Actualiza el valor de la línea base

      // Llamamos a la acción de Vuex para guardar el valor en la base de datos
      const payload = { 
        path:`secadero/variables/baseLineaValue`,
        body: {memory: this.baseLineValue }
      };
      const success = await this.postData(payload);

      console.log("success"+success);
      
      
      if (success) {
        alert("Valor de la línea guardado correctamente.");
      } else {
        alert("Hubo un error al guardar el valor.");
      }
      } else {
        alert("Por favor ingrese un valor numérico válido.");
      }
    },
    async fetchBaseLineValue() {
      try {
        // Llama a la API para obtener el valor de la base de datos
        const payload = { 
          path: 'secadero/variables/baseLineaValue',
        };
        const response = await this.getData(payload);
        if (response.ok) {
          const baseLineFromDB = parseFloat(response.results.rows[0].valor);
          if (!isNaN(baseLineFromDB)) {
            this.baseLineValue = baseLineFromDB; // Asigna el valor recuperado
            this.horizontalLineValue = baseLineFromDB; 
          }
        } else {
          console.error('Error al obtener el valor desde la base de datos:', response.error);
        }
      } catch (error) {
        console.error('Error al obtener el valor desde la base de datos:', error);
      }
    },
    
  // Función para actualizar los datos del gráfico con los nuevos valores
  updateChartData(b) {
    // Evita la recursión infinita verificando el estado de loadingData
    if (!Array.isArray(b) || this.loadingData) {
      // Si hay nuevos datos pero estamos cargando, no hacemos nada
      return;
    }
    // Recorre cada elemento del array y agrega los datos al dataset correspondiente
    b.forEach(item => {
      const limiteTiempo = 4 * 60 * 60 * 1000; // 4 horas en milisegundos
      const timestamp = new Date(item.timestamp);

      const value = item.valor;
      // Encuentra el dataset correspondiente y agrega los datos
      const dataset = this.chartData.datasets.find(ds => ds.id === item.memoria);

      if (dataset) {
        const formattedValue = value.toFixed(dataset.precision || 0);

        dataset.data.push({ x: timestamp, y: formattedValue });
        // Eliminar el primer dato si el conjunto de datos supera las 24 horas
      if (dataset.data.length > 0 && (timestamp.getTime() - new Date(dataset.data[0].x).getTime()) > limiteTiempo) {
        dataset.data.shift(); // Remueve el primer elemento
      }

        // Aquí puedes actualizar la tabla
        if (item.memoria === "DB510DBD56") {
          this.tableData[0].valorTHorno = formattedValue ;
          this.tableData[0].timestamp = moment(timestamp).format('HH:mm:ss');
        } else if (item.memoria === "DB510DBD60") {
          this.tableData[0].timestamp = moment(timestamp).format('HH:mm:ss');
          this.tableData[0].valorTTrabajo = formattedValue;
        } 
        else if (item.memoria === "DB510DBD52") {
          this.tableData[0].valorVSinfines = value;
          this.tableData[0].timestamp = moment(timestamp).format('HH:mm:ss');
        } else if (item.memoria === "DB510DBD68") {
          this.tableData[0].valorTQuemador = formattedValue;       
          this.tableData[0].timestamp = moment(timestamp).format('HH:mm:ss');
        }
      }   
    });
  },

  async fetchVariableSettings() {
    try {
      const payload = {
        path:`secadero/variables/plc/${this.plc_id}`,
        params: {}
      }
      const response =  await this.getData(payload);
      
      if (response.ok) {
        const variables = response.variables;
        // Asigna `precision` a cada dataset en chartData según su `id`
        variables.forEach(variable => {
          const dataset = this.chartData.datasets.find(ds => ds.id === variable.memory);
          if (dataset) {
            dataset.precision = variable.precision ; 
          }
        });
      }
    } catch (error) {
      console.error("Error al obtener configuraciones de variables:", error);
    }
  },

  async fetchHistoricalData() {
    this.loadingData = true; // Comenzar a cargar datos
    const now = new Date();
    const last4Hours = new Date(now);
    last4Hours.setHours(now.getHours() - 4);
    const firstDay = last4Hours.toISOString();
    const lastDay = now.toISOString();
    

    try {
      // const response = await axios.get('variables/history', {
      //   params: { firstDay, lastDay }
      // });
      const payload = {
        path:"secadero/variables/history",
        params: {
                    firstDay: firstDay,
                    lastDay: lastDay}
      }
      const response =  await this.getData(payload);

      if (response.ok) {
        const historicalData = response.results;
        // Ordenar los datos históricos
        historicalData.sort((a, b) => new Date(a.real_timestamp) - new Date(b.real_timestamp));
        

        historicalData.forEach(item => {
            const timestamp = moment(item.real_timestamp)
            const temperaturaTrabajo = item.temperatura_trabajo;
            const temperaturaHorno = item.temperatura_horno;
            const velocidadSinfines = item.velocidad_sinfines;
            const temperaturaQuemador = item.temperatura_quemador;

            // Busca el dataset correspondiente y guarda la precisión
            const datasetTrabajo = this.chartData.datasets.find(ds => ds.id === "DB510DBD56");
            const datasetHorno = this.chartData.datasets.find(ds => ds.id === "DB510DBD60");
            const datasetVelocidadSinfines = this.chartData.datasets.find(ds => ds.id === "DB510DBD52");
            const datasetTemperaturaQuemador = this.chartData.datasets.find(ds => ds.id === "DB510DBD68");
            
            // Guarda los datos históricos con la precisión correspondiente
            if (datasetTrabajo) {
              const formattedValueTrabajo = parseFloat(temperaturaTrabajo).toFixed(datasetTrabajo.precision || 0);
              datasetTrabajo.data.push({ x: timestamp, y: formattedValueTrabajo });
            }
            if (datasetHorno) {
              const formattedValueHorno = parseFloat(temperaturaHorno).toFixed(datasetHorno.precision || 0);
              datasetHorno.data.push({ x: timestamp, y: formattedValueHorno });
            }
            if (datasetVelocidadSinfines) {
              const formattedValueSinfines = parseFloat(velocidadSinfines).toFixed(datasetVelocidadSinfines.precision || 0);
              datasetVelocidadSinfines.data.push({ x: timestamp, y: formattedValueSinfines });
            }
            if (datasetTemperaturaQuemador) {
              const formattedValueQuemador = parseFloat(temperaturaQuemador).toFixed(datasetTemperaturaQuemador.precision || 0);
              datasetTemperaturaQuemador.data.push({ x: timestamp, y: formattedValueQuemador });
            }
            
          });
      }
    } catch (error) {
      console.error("Error al obtener datos históricos:", error);
    } finally {
      this.loadingData = false; // Finalizar la carga
    }
  },
},
created() {
  
  
},
async mounted() {
  // this.chartData = chartData;
  this.loadingData=false;
  await this.fetchVariableSettings(); // Obtiene las configuraciones
  await this.fetchHistoricalData();
  await this.fetchBaseLineValue();
  this.doSubscribe('secadero');
  this.client.on('message', (topic, message) => {
    const b = JSON.parse(message);
    // Actualiza los datos del gráfico solo si no estamos cargando
    this.updateChartData(b);
  });
}
}
</script>

<style scoped>
.display-1 {
  text-align: center;
  margin-left: 2%,
}

.line-chart-secadero {
  width: 95%; 
  height: 300px; /* Ajustar según sea necesario */
  margin: 2%;
}

.current-temperatures-title {
  text-align: left;
  font-size: 20px;
  font-weight: bold;
  margin-top: 100px;
  margin-left: 2%;
}

.temperature-table {
  margin-top: 20px;
  margin-left: 2%;
  width: 95%;
  table-layout: fixed;
}

.mt-4{
  margin-left: 2%;
}


</style>
